import {HTMLAttributes} from 'react';
import {SchemeLink} from '../../../applink/SchemeLink';
import {twMerge} from '../../../common/twMerge';
import {useIsResponsiveFoldable} from '../../../common/useIsResponsiveFoldable.hook';
import {BannerItem} from '../../../graphql/generated/types';
import {Image} from '../../atoms/Image/Image';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';

export interface OperationDayOfWeekCardBannerProps
  extends HTMLAttributes<HTMLDivElement> {
  bannerItem: BannerItem;
}

export function OperationDayOfWeekCardBanner({
  bannerItem,
  className,
  ...props
}: OperationDayOfWeekCardBannerProps) {
  const isTabletOrGreater = useIsResponsiveFoldable();

  return (
    <SchemeLink scheme={bannerItem.scheme || undefined}>
      <div
        className={twMerge('w-full overflow-hidden rounded-8pxr', className)}
        aria-label={bannerItem.title || '운영 배너 이미지'}
        {...props}
      >
        <Image
          src={bannerItem.thumbnail}
          alt={bannerItem.altText || '운영 배너 이미지'}
          className="h-full w-full object-cover object-center"
          ratio={
            ThumbnailRatio[
              isTabletOrGreater
                ? ThumbnailType.OperationDayOfWeekCardBanner
                : ThumbnailType.OperationDayOfWeekCardBannerMobile
            ]
          }
        />
      </div>
    </SchemeLink>
  );
}
